<template>
  <div>
    <swiper ref="leftSlide" :options="swiperOptions" :key="swiperKey">
      <swiper-slide v-for="(item, idx) in swiperImages" :key="idx">
        <img :src="item" alt="" width="100%"/>
      </swiper-slide>
      <div  class="swiper-button-prev nav-btn"  slot="button-prev" :style="{left: '40px', backgroundImage: `url(${navImg[0]})`}"></div>
      <div  class="swiper-button-next nav-btn"   slot="button-next" :style="{right: '40px', backgroundImage: `url(${navImg[1]})`}"></div>
    </swiper>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
export default {
  name: "SysSwiper",
  components: { swiper, swiperSlide },
  props: {
    navigator: {
      type: Boolean,
      default: false
    },
    swiperImages: {
      type: Array
    },
    navImg: {
      type: Array
    },
    slidesPerView:{
      type:Number,
      default:1,
    }
  },
  computed: {
    swiperOptions(){
        return {
          speed: 1000,
          loop: true,
          slidesPerView:this.slidesPerView,
          autoplay: {
            disableOnInteraction: false,
            delay: 3000
          },
          navigation: {
            nextEl: ".next-btn",
            prevEl: ".prev-btn"
          }
        }
    }
  },
  watch: {
    slidesPerView(newVal){
      console.log(newVal);
    }
  },  
  mounted(){
    console.log(this.swiperOptions);
    this.swiperKey +=1
  },
  data() {
    return {
      swiperKey:1,
      // swiperOptions: {
      //   speed: 1000,
      //   loop: true,
      //  slidesPerView: 3, 
      //   autoplay: {
      //     disableOnInteraction: false,
      //     delay: 3000
      //   },
      //   navigation: {
      //     nextEl: ".next-btn",
      //     prevEl: ".prev-btn"
      //   }
      // }
    }
  }
}
</script>

<style scoped>
.nav-btn {
  height: 70px;
  width: 70px;
  position: absolute;
  top: calc(50% - 35px);
  cursor: pointer;
  background-size: 100% 100%;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  color: #707070;
}
</style>



// WEBPACK FOOTER //
// src/components/common/SysSwiper.vue